import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { Reveal } from "./Reveal";
import { ArrowRight, PhoneCall } from "lucide-react";

export const FinalCTA = ({ heading, copy }) => {
  const { t, p } = useLang();
  return (
    <section className="relative bg-[#08090A] overflow-hidden" data-testid="final-cta">
      <div className="absolute inset-0 opacity-[0.12]" aria-hidden="true"
        style={{ backgroundImage: "radial-gradient(#FF6600 1px, transparent 1px)", backgroundSize: "26px 26px" }} />
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[520px] h-[520px] rounded-full bg-[#FF6600]/10 blur-3xl" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-20 lg:py-28 text-center">
        <Reveal>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black tracking-tight text-white max-w-3xl mx-auto">
            {heading || t.finalCta.heading}
          </h2>
          <p className="mt-5 text-base sm:text-lg text-white/65 max-w-2xl mx-auto">{copy || t.finalCta.copy}</p>
          <div className="mt-9 flex flex-wrap justify-center gap-3">
            <Link to={p("demander-un-devis")} data-testid="cta-quote"
              className="inline-flex items-center gap-2 bg-[#FF6600] hover:bg-[#FF9900] text-[#08090A] font-black rounded-full px-7 py-3.5 text-sm transition-colors shadow-[0_0_25px_rgba(255,102,0,0.4)]">
              {t.nav.quote} <ArrowRight size={16} />
            </Link>
            <Link to={p("verifier-la-couverture")} data-testid="cta-coverage"
              className="inline-flex items-center gap-2 border border-white/25 hover:border-[#FF6600] text-white font-bold rounded-full px-7 py-3.5 text-sm transition-colors">
              {t.nav.coverage}
            </Link>
            <Link to={p("contact")} data-testid="cta-expert"
              className="inline-flex items-center gap-2 text-white/80 hover:text-[#FF9900] font-bold rounded-full px-7 py-3.5 text-sm transition-colors">
              <PhoneCall size={16} className="text-[#FF6600]" /> {t.nav.talkExpert}
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
